/* eslint-disable */

import "babel-polyfill";

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux'
import store, { history } from './etc/store'
import ReactGA from 'react-ga';
import App from './components/App'
import CSS from './styles/css/superface.css'
import prototypes from './kit/prototypes'


prototypes()
function noop() {}
// console.log = noop;
console.warn = noop;
// console.error = noop;


history.listen((location, action) => {
  
  setTimeout( () => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  }, 1500 )

});

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

ReactGA.initialize('UA-74656785-1');
ReactGA.pageview(window.location.pathname + window.location.search);



// WEBPACK FOOTER //
// ./src/index.js